/*@flow*/
import React from 'react';
import useCommands from './useCommands';
import useContextState from './useContextState';
import cx from 'classnames';

const ToggleModeButton = () => {
  const cmd = useCommands();
  const { mode } = useContextState();

  const onToggle = () => {
    cmd.toggleDraw();
  };

  const isReady = mode === 'READY';
  return (
    <a
      data-testid="ToggleModeButton"
      className={cx('d-block p-3', {
        'bg-white': isReady,
        'bg-light': !isReady,
        'text-info': !isReady,
        'text-muted': isReady,
      })}
      onClick={onToggle}
    >
      <i className="fa fa-shapes" /> {isReady ? 'Draw' : 'Done'}
    </a>
  );
};

const ResetButton = () => {
  const cmd = useCommands();
  const { theGeom, theGeomOrig } = useContextState();
  const onReset = () => cmd.resetGeom();
  const showReset = theGeomOrig && theGeomOrig !== theGeom;

  if (!showReset) return null;

  return (
    <a
      data-testid="ResetTheGeomButton"
      className="d-block p-3 bg-white text-muted border-top"
      onClick={onReset}
    >
      <i className="fa fa-undo-alt" /> Reset
    </a>
  );
};

const Component = () => (
  <div className="border rounded text-uppercase" style={{ fontSize: '1rem' }}>
    <ToggleModeButton />
    <ResetButton />
  </div>
);

export default (Component: any);
